export default __webpack_public_path__ + "static/media/bank-icon.02d0570d.svg";